import { FormattedMessage } from "react-intl";

import { Button } from "@ps-design-system/components/Button";
import { Divider } from "@ps-design-system/components/Divider";
import { Form } from "@ps-design-system/components/Form";
import { Text } from "@ps-design-system/components/Text";

import type { AmenityOption } from "~/services/env.service";

import type { Listing } from "../../../../../types/listings.types";
import { useListingDetailsForm } from "../useListingDetailsForm";

import { AmenitiesFields } from "./form-fields/AmenitiesFields";
import { DescriptionField } from "./form-fields/DescriptionField";
import { ListingTitleField } from "./form-fields/ListingTitleField";

type ListingDetailsFormProps = {
  listing: Listing;
  amenityOptions: AmenityOption[];
};

const ListingDetailsForm = ({
  listing,
  amenityOptions,
}: ListingDetailsFormProps) => {
  const { form, onSave, errorMsg } = useListingDetailsForm(
    listing,
    amenityOptions,
  );

  const handleSave = async () => {
    const success = await onSave();
    if (success) {
      window.location.href = `/mylistings/${listing._id}`;
    }
  };

  return (
    <Form {...form}>
      <ListingTitleField />
      <DescriptionField />
      <AmenitiesFields amenityOptions={amenityOptions} />

      <Divider />

      <div className="tw-flex tw-mt-32 tw-justify-end">
        <div className="tw-flex tw-flex-col tw-self-end tw-gap-8">
          <Button
            appearance="purple"
            disabled={!form.formState.isDirty}
            onClick={handleSave}
            showSpinner={form.formState.isSubmitting}
            testId="listing-details-save-button"
          >
            <FormattedMessage
              id="hosting.listing_details.save_button"
              defaultMessage="Save"
            />
          </Button>
          {errorMsg && (
            <Text
              typeface="body-1"
              element="p"
              className="tw-text-red-800"
              testId="listing-details-submit-error"
            >
              {errorMsg}
            </Text>
          )}
        </div>
      </div>
    </Form>
  );
};

export { ListingDetailsForm };
